function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { useSelector } from 'react-redux';
import { createTimezonedDate } from '../../../date';
export default function CommentsSection(_ref) {
  let {
    comments
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const styleCommon = {
    color: 'black',
    padding: '10px'
  };
  const styleOtherUserCommentBody = _objectSpread(_objectSpread({}, styleCommon), {}, {
    backgroundColor: '#f2f2f2'
  });
  const styleOwnCommentBody = _objectSpread(_objectSpread({}, styleCommon), {}, {
    backgroundColor: '#a0f7ff',
    float: 'right',
    clear: 'both'
  });
  const commentUi = comment => {
    var _comment$user, _comment$user2;
    const isOwnComment = ((_comment$user = comment.user) === null || _comment$user === void 0 ? void 0 : _comment$user.id) === user.id;
    const float = isOwnComment ? 'right' : 'unset';
    return /*#__PURE__*/React.createElement("div", {
      key: comment.id,
      className: "mb-3",
      style: {
        float,
        clear: 'both',
        marginRight: '10px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        float
      }
    }, (_comment$user2 = comment.user) === null || _comment$user2 === void 0 ? void 0 : _comment$user2.name), /*#__PURE__*/React.createElement("div", {
      style: isOwnComment ? styleOwnCommentBody : styleOtherUserCommentBody
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        float,
        overflowWrap: 'anywhere'
      }
    }, comment.body), /*#__PURE__*/React.createElement("div", {
      style: {
        clear: 'both',
        color: '#737373'
      }
    }, createTimezonedDate(new Date(comment.created_at)).toCustomLocaleTimeString())));
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      maxHeight: '500px',
      overflowY: 'auto',
      padding: '0 0px'
    }
  }, comments.map(comment => commentUi(comment)));
}